









import Vue from "vue";
import GoHome from "@/components/GoHome.vue";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    components: { GoHome },
    methods: {
        ...mapActions(["getOrgConfig"])
    },
    computed: {
        ...mapGetters(["orgConfig"])
    },
    async mounted() {
        await this.getOrgConfig();
    },
    watch: {
        orgConfig(val) {
            const newStyleTag = document.createElement("style");
            newStyleTag.textContent = this.orgConfig.customizedThemeColors;
            document.head.appendChild(newStyleTag);
        }
    }
});
